import React from 'react';
import { useSubdomainInfo } from '@bvt-hooks';

/**
 * @param {object} props
 * @param {'auth'|'footer'|'navbar'} props.context - Jenis penggunaan logo
 * @param {string} [props.className] - Class styling dari parent
 */
export const SubdomainLogo = ({ context, className = '' }) => {
  const { subdomain, isBVT } = useSubdomainInfo();
  const path = isBVT ? 'intelligence' : subdomain;
  const logo = path === 'intelligence' && context === 'navbar' ? 'auth' : context;

  return (
    <img
      alt={`logo ${path}`}
      className={className}
      src={`/assets/images/${path}/${logo}.png`}
    />
  );
};
